import { Component } from "react";
import faltan from "../assets/Varios/faltan.png"
import SocialBlock from "./SocialBlock.js";
import "./Main.css";

class Footer extends Component {
  constructor(props) {
    super(props);

    const eventDate = new Date(localStorage.getItem("eventDate"));
    const finEvento = new Date(localStorage.getItem("finevento"));

    this.state = {
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
      stopped: false,
      evento: false,
      eventDay: eventDate,
      finEvento: finEvento,
      energyPct: 0,
    };
  }

  // "ENERGY" es un loop decorativo: sube de 0 a 100 despacio y vuelve a arrancar.
  static ENERGY_CYCLE_MS = 12000;

  componentDidMount() {
    this.timer();
    this.interval = setInterval(this.timer, 1000);

    this.energyStart = Date.now();
    this.energyFrame = setInterval(() => {
      const elapsed = (Date.now() - this.energyStart) % Footer.ENERGY_CYCLE_MS;
      const energyPct = Math.round((elapsed / Footer.ENERGY_CYCLE_MS) * 100);
      this.setState({ energyPct });
    }, 100);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.energyFrame);
  }

  timer = () => {
    const now = new Date();
    const { eventDay, finEvento } = this.state;
    const secsToStart = Math.floor((eventDay.getTime() - now.getTime()) / 1000);
    const secsToEnd = Math.floor((finEvento.getTime() - now.getTime()) / 1000);

    if (secsToEnd <= 0) {
      this.setState({ stopped: true, evento: false });
      clearInterval(this.interval);
      return;
    }

    if (secsToStart <= 0 && secsToEnd > 0) {
      this.setState({ stopped: true, evento: true });
      return;
    }

    const days = Math.floor(secsToStart / 86400);
    const hoursLeft = secsToStart - days * 86400;
    const hours = Math.floor(hoursLeft / 3600);
    const minutesLeft = hoursLeft - hours * 3600;
    const min = Math.floor(minutesLeft / 60);
    const sec = secsToStart % 60;

    this.setState({ days, hours, min, sec, stopped: false, evento: false });
  };

  renderTimeBlock(value, label) {
    const isMobile = window.innerWidth <= 768;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: isMobile ? "58px" : "90px",
        }}
      >
        <div
          style={{
            fontFamily: "var(--tera-pixel)",
            fontWeight: 700,
            fontSize: isMobile ? "1.7em" : "2.6em",
            color: "var(--tera-mint)",
            lineHeight: 0.9,
            textAlign: "center",
          }}
        >
          {String(value).padStart(2, "0")}
        </div>

        <div
          style={{
            fontFamily: "Halogen-Regular",
            fontSize: isMobile ? "0.45em" : "0.7em",
            color: "#fff",
            marginTop: isMobile ? "2px" : "4px",
            textAlign: "center",
            letterSpacing: "0.5px",
          }}
        >
          {label}
        </div>
      </div>
    );
  }

  renderEnergyBar(isMobile) {
    const segments = 16;
    const energyPct = this.state.energyPct;
    const filled = Math.round((energyPct / 100) * segments);
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: isMobile ? "center" : "flex-start",
          gap: "3px",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-end", gap: "2px" }}>
          {Array.from({ length: segments }).map((_, i) => (
            <div
              key={i}
              className={i < filled ? "tera-energy-segment" : undefined}
              style={{
                width: "3.5px",
                height: isMobile ? "10px" : "14px",
                borderRadius: "1px",
                animationDelay: i < filled ? `${i * 90}ms` : undefined,
                background:
                  i < filled
                    ? "linear-gradient(180deg, var(--tera-mint), var(--tera-cyan))"
                    : "rgba(255,255,255,0.15)",
              }}
            />
          ))}
        </div>
        <div
          style={{
            fontWeight: 700,
            fontSize: "0.65em",
            color: "var(--tera-mint)",
            letterSpacing: "0.5px",
          }}
        >
          ENERGY: {energyPct}%
        </div>
      </div>
    );
  }


	renderSocialBlock(isMobile) {
    return <SocialBlock isMobile={isMobile} style={{ pointerEvents: "auto" }} />;
  }

	renderDesktopFooter(days, hours, min, sec) {
	   const isMobile = window.innerWidth <= 768;
    return (
      <>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr",
            alignItems: "center",
            padding: "10px 34px 0 34px",
            boxSizing: "border-box",
            backgroundColor: "var(--tera-bg)",
          }}
        >
          <div style={{ justifySelf: "start" }}>
            {this.renderEnergyBar(false)}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              justifySelf: "center",
            }}
          >
            <img
              src={faltan}
              alt="Seguinos en Instagram @tera.oficial.ok"
              style={{ height: isMobile ? "26px" : "34px", width: "auto" }}
            />

            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
                flexWrap: "nowrap",
              }}
            >
              {this.renderTimeBlock(days, "DÍAS")}
              {this.renderTimeBlock(hours, "HORAS")}
              {this.renderTimeBlock(min, "MINUTOS")}
              {this.renderTimeBlock(sec, "SEGUNDOS")}
            </div>
          </div>

          <div />
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "6px 0 10px",
            boxSizing: "border-box",
            backgroundColor: "Transparent",
          }}
        >
          {this.renderSocialBlock(false)}
        </div>
      </>
    );
  }

	renderMobileFooter(days, hours, min, sec) {
	    const isMobile = window.innerWidth <= 768;
    return (
      <>
        <div
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "6px 10px 0 10px",
            boxSizing: "border-box",
            gap: "3px",
            backgroundColor: "var(--tera-bg)",
          }}
        >
          {/* 1. energy */}
          {this.renderEnergyBar(true)}

          {/* 2. faltan */}
          <img
            src={faltan}
            alt="Seguinos en Instagram @tera.oficial.ok"
            style={{ height: isMobile ? "26px" : "34px", width: "auto" }}
          />

          {/* 3. números */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "2px",
              flexWrap: "nowrap",
              width: "100%",
            }}
          >
            {this.renderTimeBlock(days, "DÍAS")}
            {this.renderTimeBlock(hours, "HORAS")}
            {this.renderTimeBlock(min, "MINUTOS")}
            {this.renderTimeBlock(sec, "SEGUNDOS")}
          </div>
        </div>

        {/* 4. redes + sponsors */}
        <div
          style={{
            width: "100%",
            paddingBottom: "8px",
            boxSizing: "border-box",
          }}
        >
          {this.renderSocialBlock(true)}
        </div>
      </>
    );
  }

  render() {
    const isMobile = window.innerWidth <= 768;
    const { stopped, evento, days, hours, min, sec } = this.state;

    const footerHeight = isMobile ? 150 : 130;

    const containerStyle = {
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "100%",
      height: `${footerHeight}px`,
      zIndex: 50,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: isMobile ? "4px" : "6px",
      background: "transparent",
      pointerEvents: "none",
    };

    if (stopped && !evento) {
      return (
        <div style={containerStyle}>
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "var(--tera-bg)",
              fontFamily: "var(--tera-pixel)", fontWeight: 700,
              fontSize: isMobile ? "1.7em" : "2.5em",
              color: "var(--tera-cyan)",
            }}
          >
            ¡GRACIAS POR VENIR!
          </div>
        </div>
      );
    }

    if (stopped && evento) {
      return (
        <div style={containerStyle}>
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "var(--tera-bg)",
              fontFamily: "var(--tera-pixel)", fontWeight: 700,
              fontSize: isMobile ? "1.5em" : "2.5em",
              color: "var(--tera-pink)",
            }}
          >
            ¡EMPEZÓ LA FIESTA!
          </div>
        </div>
      );
    }

    return (
      <div style={containerStyle}>
        {isMobile
          ? this.renderMobileFooter(days, hours, min, sec)
          : this.renderDesktopFooter(days, hours, min, sec)}
      </div>
    );
  }
}

export default Footer;
